import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="S" transform="translate(34, 24) scale(0.65)">
        <path
          d="M 0 56.801 L 7.2 55.501 Q 9.1 68.701 23.5 68.701 Q 39.8 68.701 39.8 55.801 Q 39.8 50.201 36.8 47.501 Q 33.8 44.801 26.8 42.901 L 20.2 41.001 Q 9.9 38.201 5.7 33.851 Q 1.5 29.501 1.5 20.551 Q 1.5 11.601 7.5 5.801 Q 13.5 0.001 24.95 0.001 Q 36.4 0.001 41.6 4.901 Q 46.8 9.801 48.2 19.001 L 41 20.301 Q 39.1 7.101 25.8 7.101 Q 10.3 7.101 10.3 20.001 Q 10.3 25.601 13.05 28.351 Q 15.8 31.101 22.4 32.901 L 29.3 34.801 Q 39.9 37.801 44.25 42.101 Q 48.6 46.401 48.6 55.351 Q 48.6 64.301 42.35 70.051 Q 36.1 75.801 24.25 75.801 Q 12.4 75.801 6.9 70.901 Q 1.4 66.001 0 56.801 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
